import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconMoveFolderInside: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconMoveFolderInside"><Path d="M13 19.5H2.5V3.5H10L12 6.5H21.5V13" stroke="currentColor"/><Path d="M22.5 17.5H19.5H16.5" stroke="currentColor" strokeLinecap="square"/><Path d="M18.5 14.5L15.5 17.5L18.5 20.5" stroke="currentColor"/></CentralIconBase>;
});

export default IconMoveFolderInside;
